'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvg = require('react-svg');

var _alignments = require('../../../constants/alignments');

var _colors = require('../../../constants/colors');

var _sizes = require('../../../constants/sizes');

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _header = require('../../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _contactInfo = require('./contactInfo');

var _contactInfo2 = _interopRequireDefault(_contactInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Headline = function (_React$Component) {
	_inherits(Headline, _React$Component);

	function Headline(props) {
		_classCallCheck(this, Headline);

		var _this = _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).call(this, props));

		_this.state = {
			contactImage: true
		};
		return _this;
	}

	_createClass(Headline, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var width = 270;
			var height = 350;

			if (this.props.isMobile) {
				width = width * 0.5;
				height = height * 0.5;
			}

			if (this.props.isTablet) {
				width = width * 0.75;
				height = height * 0.75;
			}

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_grid2.default,
					null,
					_react2.default.createElement(
						_row2.default,
						{ nogutter: true },
						this.state.contactImage && _react2.default.createElement(
							_column2.default,
							{ xs: 12,
								md: 3
							},
							_react2.default.createElement(_reactSvg.ReactSVG, {
								afterInjection: function afterInjection(error) {
									if (error) _this2.setState({ contactImage: false });
								},
								beforeInjection: function beforeInjection(svg) {
									svg.setAttribute('style', 'width: ' + width + 'px; height: ' + height + 'px');
								},
								src: process.env.PUBLIC_URL + '/assets/contactDetails_image.svg'
							})
						),
						_react2.default.createElement(_column2.default, { md: 2 }),
						_react2.default.createElement(
							_column2.default,
							{ xs: this.state.contactImage ? 8 : 12,
								md: this.state.contactImage ? 5 : 8
							},
							_react2.default.createElement(
								_container2.default,
								{ fullSize: true,
									verticalAlignment: _alignments.Alignments.top,
									bottom: _sizes.Sizes.none
								},
								_react2.default.createElement(_header2.default, { textAlign: _alignments.Alignments.left,
									color: _colors.Colors.Primary,
									size: this.context.screen.isMobile ? _sizes.Sizes.lg : _sizes.Sizes.xl,
									left: this.context.screen.isMobile && _sizes.Sizes.xs,
									top: _sizes.Sizes.md,
									bottom: _sizes.Sizes.none,
									text: this.props.primaryHeader
								}),
								_react2.default.createElement(_header2.default, { textAlign: _alignments.Alignments.left,
									color: _colors.Colors.SecondaryText,
									size: this.context.screen.isMobile ? _sizes.Sizes.sm : _sizes.Sizes.md,
									left: this.context.screen.isMobile && _sizes.Sizes.xs,
									top: _sizes.Sizes.sm,
									bottom: _sizes.Sizes.xs,
									text: this.props.secondaryHedaer
								}),
								_react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
									size: this.context.screen.isMobile ? _sizes.Sizes.lg : _sizes.Sizes.xl,
									left: this.context.screen.isMobile && _sizes.Sizes.xs,
									top: _sizes.Sizes.xs,
									bottom: _sizes.Sizes.xl,
									text: this.props.label
								}),
								_react2.default.createElement(_contactInfo2.default, _extends({ callText: this.props.callText,
									smsText: this.props.smsText,
									callSetUpText: this.props.callSetUpText,
									chatText: this.props.chatText }, this.props))
							)
						),
						_react2.default.createElement(_column2.default, { md: 2 })
					)
				)
			);
		}
	}]);

	return Headline;
}(_react2.default.Component);

Headline.contextTypes = {
	screen: _propTypes2.default.object
};

exports.default = Headline;